import { CheckCircleTwoTone, CheckOutlined, ClockCircleTwoTone, CloseOutlined, ExclamationCircleTwoTone, LoadingOutlined, StarFilled, TagOutlined } from "@ant-design/icons";
import { Card, Rate, Comment, Form, Tag, Input, Spin, message, Tooltip, Divider, Modal, Button, Alert } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../ReviewsAndFaQ.css"
import { STATUS } from "../../../../../common/constants/statusFAQAndReviews";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import { authRequest } from "../../../../../common/request/authRequest";
import { authFetch } from "../../../../../common/request/authFetch";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import ReviewComment from "./ReviewComment";
import { ReviewAnswer } from "../../../../components/model/reviews/reviews/ReviewAnswer";
import { EmojiPickerCustom } from "../../../../components/design/EmojiPicker/EmojiPickerCustom";
import { useIsAuthorized } from "../../../common/roles/Roles";
import moment from "moment";
import { AddLabelModal } from "./drawer/AddLabelModal";
import { Label } from "./Label";
import { getReviewStatus } from "../../../../../common/utils/ReviewUtils";
import { MediaGridScroll } from "./MediaGridScroll";

export default function CardDetailsReview({ reviewId, onFinish, drawer = false, categories}: any) {  

  type LanguageCode = '' | 'es' | 'en' | 'fr' | 'it' | 'pt' | 'ca' | 'ga';

  const [status, setStatus] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [review, setReview] = useState<any>(null);
  const [reviewStatus, setReviewStatus] = useState<any>({color: 'white', tooltip:'', status:'', alert: <></>});
  const [refreshReview, setRefreshReview] = useState(true);
  const [replyForm] = Form.useForm();
  const { t } = useTranslation();
  const { projectGroup } = useAuth();
  const isAuthorized = useIsAuthorized();
  const [addLabelModal, setAddLabelModal] = useState<any>(null);

  const [selectedLanguage, setSelectedLanguage] = useState<LanguageCode>('');

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLanguage(event.target.value as LanguageCode);
  };

  const submitReply = async ({ comment }: { comment: string }): Promise<void> => {

    const data = {
      comment,
      reviewId: review.name
    };
    await authFetch(
      `${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/reviews/reply',
      { method: 'PUT', data: data }
    )
      .then((res) => {
        if (res) {
          message.success(t('view.forms.modal.reviews.reply.success', { name: review.reviewerDisplayName }), 3);
          //debugger;
          //setRefreshReview(!refreshReview);
          setStatus('');
          onFinish();
        } else {
          message.error(t('view.forms.modal.reviews.reply.error', { name: review.reviewerDisplayName }), 3);
        }
      });
  };

  useEffect(() => {

    setStatus('')
    replyForm.resetFields();
    //console.log("/review" + reviewId)
    if (reviewId !== null) {

      setReview(null);
      authRequest(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + reviewId + '/review', {}).then((data) => {
        if (data.deleted) {
          reviewId = null;
          message.info("Esta reseña ya no existe en Google");
          onFinish();
        /*} else if (data.updated) {
          message.info("Reseña actualizada on la info más reciente de Google");
          onFinish();
          setReview(data.review);*/
        } else {
          setReviewStatus(getReviewStatus(data.review));
          setReview(data.review);
        }
      })
    } 
  }, [reviewId, refreshReview, /*projectGroup.group*/])

    
  const daysAgo = (date: string): number => {
    const oneDay: number = 24 * 60 * 60 * 1000
    return Math.round(Math.abs((Date.now() - new Date(date).getTime()) / oneDay));
  };

  const getResponseIa = async () => {

    setIsLoading(true)
    await authRequest(`${process.env.REACT_APP_API}/${projectGroup.group}/chat?reviewerName=${encodeURIComponent(review?.reviewerDisplayName)}&starRating=${review?.starRating}&content=${encodeURIComponent(review?.comment.originalText ? review?.comment.originalText : review?.comment.text)}&locationId=${review.locationId}&language=${selectedLanguage}`, {})
    .then((data) => {
      handleOpenTextArea(data)
      setIsLoading(false)
    }).catch((error) => {
      setIsLoading(false)
    });
  }

  const handleOpenTextArea = (responseText: any) => {
    replyForm.setFieldsValue({ comment: responseText });
  };


  const [showPicker, setShowPicker] = useState(false);

  const [cursorIndex, setCursorIndex] = useState(0);

  const handleFocus = (event:any) => {
      setShowPicker(false);        
  }

  const handleBlur = (event:any) => {
      setCursorIndex(event.target.selectionStart);
  };

  const handleEmojiClick = (emoji:any) => {    

      const textArea = replyForm.getFieldValue('comment');
      const textAreaWithEmoji = 
              textArea.slice(0, cursorIndex) +
              emoji.native +
              textArea.slice(cursorIndex);
      replyForm.setFieldsValue({ comment: textAreaWithEmoji });
  };    

  return (
    <div className={`${!drawer && 'review-faq-container'}`}
      style={{ marginTop:'15px', background: review ? reviewStatus.background : 'white' }}
    >
      {review ? (
        <Card
        className='card-layout'          
        size='small'
        extra={
          <>
            <div style={{color:reviewStatus.color, fontWeight: '600'}}>
              <reviewStatus.Icon twoToneColor={reviewStatus.color} /> {reviewStatus.tooltip}
            </div>
            <Rate
            style={{ fontSize: '18px' }}
            disabled={true}
            allowHalf
            value={review.starRating}
            />
          </>
        }
        title={
          <div>
                <span>{review.title}</span>
                {review.addressLine ? (
                  <p style={{ margin: '0px', fontSize: '14px', fontWeight: 600 }}>
                        {review.addressLine}, {review.locality}
                    </p>
                ) : (
                  <p style={{ margin: '0px', color: 'grey', fontStyle: 'italic', fontSize: '14px' }}>
                        Sin ubicación
                    </p>
                )}
            </div>
        }        
        headStyle={{ borderRadius: '10px', background: reviewStatus.background }}
        bodyStyle={{ borderRadius: '10px', background: reviewStatus.background }}
        >        
          {reviewStatus.alert}
          <Comment
            author={<div style={{ color: 'black', fontSize: '14px' }}>{review.reviewerDisplayName}</div>}
            avatar={review.reviewerProfilePhotoUrl}
            content={
              !!review.comment && <ReviewComment comment={review.comment} scope={''} reviewReplyUpdateTime={review.updateTime} isReply={false} isObsolete={false}/>
            }
            datetime={
              <small style={{ color: 'gray', display:'flex', justifyContent:'space-between' }}>
                {
                  daysAgo(review.updateTime) > 1 ?
                      <div>
                          <Tooltip title={<>
                                              <div>Creada el {moment(review.createdTime).format('ll')}</div>
                                              {!moment(review.createdTime).isSame(moment(review.updateTime)) && <div>Actualizada el {moment(review.updateTime).format('ll')}</div>}
                                          </>}>
                              {moment(review.updateTime).fromNow()}
                          </Tooltip>
                      </div>
                      :
                    <Tag color={'green'} style={{ borderRadius: '10px' }}>{t('dictionary.new.female').toUpperCase()}</Tag>
                }
              </small>
            }>
            
            <MediaGridScroll mediaItems={review.reviewMediaItems}/>
            
            {review.reviewReplyComment && <ReviewAnswer submitReply={submitReply} replyForm={replyForm} getResponseIa={getResponseIa} isLoadingIa={isLoading} review={review} onFinish={() => {/*setRefreshReview(!refreshReview);*/ onFinish()}} />}
            
            {
              isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_REVIEWS']) && !review.reviewReplyComment && status !== STATUS.REPLYING &&              
            <Button size='small' style={{ float:'right', clear:'right', margin:'0px 10px', width:'180px'}} shape='round' type='primary' onClick={() => setStatus('Replying')}>              
                {t('dictionary.reply')}
						</Button>
            }

            {!review.reviewReplyComment && status === STATUS.REPLYING &&
              <div style={{ padding: '5px 25px 25px 25px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <small style={{ color: 'slategrey' }}>{t('dictionary.ownerReply')}</small>
                  <div style={{display:'flex'}}>                      
                    <ButtonLZ                  
                        style={{ minWidth: '40px', height: '25px', borderTopLeftRadius: '14px', borderBottomLeftRadius: '14px',borderTopRightRadius: '0px', borderBottomRightRadius: '0px', borderRight: 'none' }}
                        onClick={() => {
                          if (!isLoading) {
                            getResponseIa();
                          }
                        }}
                        size='small' color='dark-white'>
                          {isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : t('reviews.page.reply.review.btn.ia')}
                    </ButtonLZ>
                        <select 
                          value={selectedLanguage}
                          onChange={handleLanguageChange}
                          title="Seleccionar Idioma Opcional" // Título para accesibilidad/tooltip
                          style={{                           
                            backgroundColor: 'var(--dark-white)', // Un color más oscuro para discreción          
                            width: '40px', 
                            height: '25px',          
                            borderTopRightRadius: '14px', 
                            borderBottomRightRadius: '14px',
                          }}>
                            <option value="">🌎</option> 
                            <option value="inglés">🇬🇧 Inglés</option>
                            <option value="italiano">🇮🇹 Italiano</option>
                            <option value="francés">🇫🇷 Francés</option>
                            <option value="portugués">🇵🇹 Portugués</option>
                            <option value="alemán">🇩🇪 Alemán</option>
                            <option value="sueco">🇸🇪 Sueco</option>
                            <option value="español">🇪🇸 Español</option>        
                            <option value="catalán">ca Catalán</option>
                            <option value="gallego">ga Gallego</option>
                            <option value="valenciano">va Valenciano</option>
                            <option value="esuskera">eu Euskera</option>
                        </select>
                      </div>
                  {/*<ButtonLZ                  
                    onClick={() => {
                      if (!isLoading) {
                        getResponseIa();
                      }
                    }}
                    style={{ minWidth: '40px' }}
                  size='small' color='dark-white'>{isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : t('reviews.page.reply.review.btn.ia')}</ButtonLZ>*/}
                </div>

                <Form layout='vertical'
                  form={replyForm}
                  onFinish={submitReply}>

                  <Form.Item name='comment'>
                    <Input.TextArea
                      style={{ width: '100%', borderRadius: '15px' }}
                      className='input-field'
                      rows={6}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                    />
                  </Form.Item>
                  <a className='review-btn'
                    onClick={() => { replyForm.resetFields(); setStatus(''); }}
                  >
                    <CloseOutlined /> {t('dictionary.cancel')}
                  </a>
                  <a className='review-btn'
                    onClick={() => { replyForm.submit(); }}
                  >
                    <CheckOutlined /> {t('dictionary.accept')}
                  </a>
                  <EmojiPickerCustom  handleEmojiClick={handleEmojiClick} showPicker={showPicker} setShowPicker={setShowPicker}/>
                </Form>
              </div>
            }
          </Comment>
          <br/>

          {isAuthorized(['ROLE_ADMIN', 'ROLE_SENTIMENT_ANALYSIS']) &&
          <>
            <Divider/>
            <div style={{display: 'flex', justifyContent:'center', flexWrap: 'wrap'}}>
                {review.commentLabels?.map((label: any) => {
                return <Label reviewId={review.name} label={label} showCategory onChange={() => setRefreshReview(!refreshReview)}/>
                })}
            </div> 
            <div style={{ display: 'flex', justifyContent: 'center', alignItems:'center', padding:'2px 10px', margin:'7px 0px', borderRadius:'5px' }}>
              <div>
              {categories?.map((category: any) => {
                return <ButtonLZ size='small' type='text' onClick={() => { setAddLabelModal({reviewId: review.name, category: category.name, score: review.starRating}) }}>
                            <small>+ {category.name}</small>
                        </ButtonLZ>      })}              
              </div>
            </div>              
          </>
          }          
        </Card>
      ) :
        <div className="no-row-select">
          <Spin/>
        </div>
      }
      <div style={{color:'transparent'}}>
        <div>Sincronizada: {review?.syncDateTime && moment(review.syncDateTime).format('ll')}</div>        
        <div>Actualizada: {review?.syncUpdateTime && moment(review.syncUpdateTime).format('ll')}</div>
      </div>
    { addLabelModal && <AddLabelModal reviewId={addLabelModal.reviewId} score={addLabelModal.score} category={addLabelModal.category} onFinish={() => {setAddLabelModal(null); setRefreshReview(!refreshReview); onFinish()}}/> }                            
    </div>
  );
}